export default __webpack_public_path__ + "static/media/info-tooltip-circle.fd097baf.png";